// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
visiba-payment .paymentBox {
  position: relative;
  background-color: var(--c_backgroundBox);
  border-radius: 4px;
  margin-bottom: 2px;
  height: 0px;
  transition: all 0.5s ease-in-out;
  overflow: hidden;
  box-sizing: border-box;
}
visiba-payment .paymentBox > div {
  padding: 40px 0px;
  transition: opacity 0.25s ease-in-out;
  opacity: 0;
  position: absolute;
  width: 100%;
  top: 0px;
  pointer-events: none;
}
visiba-payment .paymentBox .hide {
  visibility: hidden;
}
visiba-payment .paymentBox .paymentTitle {
  color: var(--c_textBody);
}
visiba-payment .paymentBox .continueActions .continue .btn {
  width: 100%;
}
visiba-payment .paymentBox .continueActions .cancel {
  text-align: center;
}
visiba-payment .paymentBox .paymentOptions .paymentChoices {
  margin-bottom: 10px;
}
visiba-payment .paymentBox .paymentFrame iframe {
  width: 100%;
  height: 280px;
  border: none;
  position: relative;
  z-index: 1;
}
visiba-payment .paymentBox .paymentFrame .loadingIcon {
  width: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
visiba-payment .paymentBox .paymentFailed .failedMessage {
  min-height: 50px;
  color: var(--c_mainColorDark);
}
visiba-payment .paymentBox .paymentFailed .paymentTitle {
  display: inline-block;
}
visiba-payment .paymentBox .paymentFailed visiba-svg {
  display: inline-block;
  vertical-align: middle;
  margin-top: -8px;
  width: 40px;
}
visiba-payment .paymentBox .paymentFailed visiba-svg .fill {
  fill: var(--c_mainColorLight);
}
visiba-payment .paymentBox .paymentFailed h2 {
  font-weight: bold;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
